import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { db } from '../firebase'; 
import { ref, push } from 'firebase/database';
// PASTIKAN IMPORT CSS DI SINI
import './FeedbackModal.css'; 

const FeedbackModal = ({ isOpen, onClose }) => {
  const [msg, setMsg] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!msg.trim()) return;

    setStatus('sending');
    try {
      await push(ref(db, 'feedbacks'), {
        message: msg,
        timestamp: Date.now(),
        device: navigator.userAgent 
      });
      setStatus('success');
      setTimeout(() => {
        onClose();
        setMsg('');
        setStatus('');
      }, 2000);
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          className="f-overlay" 
          initial={{ opacity: 0 }} 
          animate={{ opacity: 1 }} 
          exit={{ opacity: 0 }}
          onClick={onClose} // Klik di luar untuk menutup
        >
          <motion.div 
            className="f-modal"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            onClick={(e) => e.stopPropagation()} // Cegah modal ikut tertutup saat diklik
          >
            <button className="f-close" onClick={onClose}>&times;</button>
            
            {status === 'success' ? (
              <div className="f-success">
                <h3>Terimakasih Sudah Mengirim!</h3>
                <p>We'll look into it ASAP.</p>
              </div>
            ) : (
              <div className="f-container">
                <h2>Beri Saran Kamu!</h2>
                <p>Tell us what's on your mind...</p>
                <form onSubmit={handleSubmit}>
                  <textarea 
                    placeholder="Type here..."
                    value={msg}
                    onChange={(e) => setMsg(e.target.value)}
                    maxLength={500}
                    className="f-textarea"
                  />
                  <button 
                    type="submit" 
                    className="f-submit-btn" 
                    disabled={status === 'sending'}
                  >
                    {status === 'sending' ? 'Sending...' : 'Send Feedback'}
                  </button>
                </form>
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FeedbackModal;